import { Sparkles } from "lucide-react";
import useSubscription from "@/hooks/useSubscription";

/**
 * Small gold pill shown wherever we want to reassure a subscriber that they
 * are, in fact, a member. Silent (renders nothing) when the visitor has no
 * active subscription — safe to drop anywhere.
 *
 * Variants:
 *   - "chip" (default): compact pill with icon, ideal for headers
 *   - "hero":           bigger version for the dashboard hero section
 */
export default function SubscribedBadge({ variant = "chip", className = "" }) {
  const { active, row, loading } = useSubscription();
  if (loading || !active) return null;

  if (variant === "hero") {
    return (
      <div
        className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[color:var(--gold)]/40 bg-[color:var(--gold)]/10 ${className}`}
        data-testid="subscribed-badge-hero"
      >
        <Sparkles size={12} className="text-[color:var(--gold)]" />
        <span className="label-overline text-[10px] text-[color:var(--gold)]">
          Subscribed · unlimited readings
        </span>
        {row?.cancel_at_period_end && (
          <span className="font-serif-italic text-[10px] text-[color:var(--rose-gold)] ml-1">
            cancels soon
          </span>
        )}
      </div>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[color:var(--gold)] text-[color:var(--bg-base)] text-[10px] font-medium tracking-wide ${className}`}
      title={row?.cancel_at_period_end ? "Cancels at period end" : "Active membership"}
      data-testid="subscribed-badge"
    >
      <Sparkles size={10} />
      <span className="uppercase tracking-wider">Subscribed</span>
    </span>
  );
}
